import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "../Pages/Dashboard";
import Invoices from "../Pages/Invoices";
import Customers from "../Pages/customers";
import Topup from "../Pages/Topup";
import MyProfile from "../Pages/MyProfile";
import UserLayout from "./UserLayout";
import ForgotPassword from "../Pages/authentication/ForgotPassword";
import Logs from "../Pages/logs";
import AutoLogs from "../Pages/auto_logs";
import AuthTheme from "../theme/AuthTheme";
import Login from "../Pages/authentication/Login";
import TwoStepVerification from "../Pages/authentication/TwoStepVerification";
import ForgotPasswordLinkSentSuccessfully from "../Pages/authentication/ForgotPasswordLinkSentSuccessfully";
import PaymentSuccess from "../Pages/PaymentSuccess";
import PaymentFailed from "../Pages/PaymentFailed";
import ChangePassword from "../Pages/authentication/ChangePassword";
import PasswordChangedSuccessfully from "../Pages/authentication/PasswordChangedSuccessfully";

import Page404 from "../Pages/errors/Page404";
import Api_Docs from "../Pages/Api_Docs";


const MainRoutes = () => {
  // const LandingLayout = ({ selectedThemeStr, children }) => {
  //   // const CHOSEN_THEME = localStorage.getItem("TYPE_OF_THEME") || TYPE_OF_THEME.DEFAULT;
  //   return (
  //     <>
  //       <React.Suspense fallback={<></>}>
  //         <LandingTheme />
  //       </React.Suspense>
  //       {children}
  //     </>
  //   );
  // };
  const LazyAuthTheme = ({ selectedThemeStr, children }) => {
    // const CHOSEN_THEME = localStorage.getItem("TYPE_OF_THEME") || TYPE_OF_THEME.DEFAULT;
    return (
      <>
        <React.Suspense fallback={<></>}>
          <AuthTheme />
        </React.Suspense>
        {children}
      </>
    );
  };

  return (
    <Routes>
            <Route
        path="/change-password/:resetPasswordToken"
        element={
          <LazyAuthTheme>
            <ChangePassword />
          </LazyAuthTheme>
        }
      />
      <Route path="/password-changed-successfully" element={<PasswordChangedSuccessfully />} />
      <Route
        path="/login"
        element={
          <LazyAuthTheme>
            <Login />
          </LazyAuthTheme>
        }
      />
      <Route path="/2-step-verification/:twoFactorToken" element={<TwoStepVerification />} />
      <Route
        path="/dashboard"
        element={
          <UserLayout>
            <Dashboard />
          </UserLayout>
        }
      />
            <Route
        path="/my-profile"
        element={
          <UserLayout>
            <MyProfile />
          </UserLayout>
        }
      />
      <Route path="/dashboard/payment-success" element={<PaymentSuccess />} />
      <Route path="/dashboard/payment-failed" element={<PaymentFailed />} />
      <Route
        path="/invoices"
        element={
          <UserLayout>
            <Invoices />
          </UserLayout>
        }
      />
            <Route
        path="/logs"
        element={
          <UserLayout>
            <Logs />
          </UserLayout>
        }
      />

<Route
        path="/auto-refund"
        element={
          <UserLayout>
            <AutoLogs />
          </UserLayout>
        }
      />

<Route
        path="/customers"
        element={
          <UserLayout>
            <Customers />
          </UserLayout>
        }
      />

      <Route
        path="/topup"
        element={
          <UserLayout>
            <Topup />
          </UserLayout>
        }
      />
            <Route path="/forgot-password-link-sent-successfully" element={<ForgotPasswordLinkSentSuccessfully />} />
      <Route
        path="/forgot-password"
        element={
          <LazyAuthTheme>
            <ForgotPassword />
          </LazyAuthTheme>
        }
      />
      <Route
        path="/api-docs"
        element={
          <UserLayout>
            <Api_Docs />
          </UserLayout>
        }
      />

      <Route
        path="*"
        element={
            <Page404 />
        }
      />
    </Routes>
  );
};

export default MainRoutes;
